import download from "downloadjs";
import { generatePdf } from "./api";

export default function useQuery({ id }) {
    const downloadPdf = async (fileName = "file.pdf", isNew = false) => {
      
        try {
            const responsePdf = await generatePdf(id, { isNew });

            if (responsePdf)
                download(responsePdf, "attendance.pdf", "application/pdf");
        } catch (error) {
            console.error("PDF download error:", error);
        }
    };

    return {
        downloadPdf,
    };
}
